import { uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import React from 'react';
import ReactQuill from 'react-quill';

import { MyRef, myStorage } from '../../Common/Firebase';
import 'react-quill/dist/quill.snow.css';

class QuillComponent extends React.Component {
  constructor(props) {
    super(props);
    this.quillRef = null;
    this.reactQuillRef = null;
    this.state = { text: '' };
  }

  componentDidMount() {
    this.attachQuillRefs();
  }

  componentDidUpdate() {
    this.attachQuillRefs();
  }

  attachQuillRefs = () => {
    if (typeof this.reactQuillRef.getEditor !== 'function') return;
    this.quillRef = this.reactQuillRef.getEditor();

    let toolbar = this.quillRef.getModule('toolbar');
    toolbar.addHandler('image', this.handleImageUpload);
  };

  handleImageUpload = () => {
    let input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.click();

    input.onchange = () => {
      setTimeout(() => {
        const file = input.files[0];
        const type = 'image'; // укажите тип файла, если он отличается

        const storageRef = MyRef(myStorage, 'test/' + type + '/' + file.name);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
          'state_changed',
          snapshot => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            this.setState({ progressFilePost: String(progress).split('.')[0] });
            // ...
          },
          error => {
            // Обработайте ошибки здесь
            console.log(error);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(downloadURL => {
              this.setState({ progressFilePost: 0, downloadURL });
              console.log({ downloadURL });
              // Вставляем изображение в редактор
              const range = this.quillRef.getSelection();
              let position = range ? range.index : 0;
              this.quillRef.insertEmbed(position, 'image', downloadURL, 'user');
            });
          },
        );
      }, 0);
    };
  };

  handleChange = value => {
    this.setState({ text: value });
  };

  render() {
    return (
      <div>
        <ReactQuill
          ref={el => {
            this.reactQuillRef = el;
          }}
          value={this.state.text}
          onChange={this.handleChange}
          modules={QuillComponent.modules}
          formats={QuillComponent.formats}
        />
      </div>
    );
  }
}

QuillComponent.modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    ['link', 'code-block', 'image'],
  ],
};

QuillComponent.formats = ['bold', 'italic', 'underline', 'strike', 'link', 'image'];

export default QuillComponent;
